// Port of api/fuel/app/classes/controller/api/monty/export/clipboard.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Search from 'offline/model/search'
import Util from 'offline/util'

function unique(ids) {
	var seen = {}
	var result = []

	for (var i = 0; i < ids.length; i++) {
		var id = Number(ids[i])
		if (!id || seen[id]) continue
		seen[id] = true
		result.push(id)
	}

	return result
}

function gameIdsForSearch(search, index) {
	if (search.get_type() === F.CACHE_COLLECTION) {
		return Util.pluck(DB.query(
			'SELECT game_id FROM collection WHERE collection_id IN(' + Util.in(index) + ')'
		), 'game_id')
	}

	if (search.get_type() === F.CACHE_PLAYS) {
		return Util.pluck(DB.query(
			'SELECT game_id FROM play WHERE play_id IN(' + Util.in(index) + ')'
		), 'game_id')
	}

	if (search.get_type() === F.CACHE_RATINGS) {
		return Util.pluck(DB.query(
			'SELECT game_id FROM rating WHERE rating_id IN(' + Util.in(index) + ')'
		), 'game_id')
	}

	return index
}

export default function(params) {
	var search = params.key ? Search.record({ where: [['search_key', '=', params.key]] }) : null
	var index
	var gameIds
	var games
	var clipboard

	if (!search) {
		return Promise.reject({ error: 'Unauthorised', offline: true })
	}

	index = params.index && params.index.length ? params.index : search.get_result_index()
	gameIds = unique(gameIdsForSearch(search, index))
	games = gameIds.length ? DB.query(
		'SELECT game_name FROM game WHERE game_id IN(' + Util.in(gameIds) + ') ORDER BY game_name ASC'
	) : []
	clipboard = games.map(function(game) {
		return game.game_name
	}).join('\n')

	return Promise.resolve({
		session: { offline: true },
		data: { clipboard: clipboard }
	})
}
